import { Pipe, PipeTransform } from '@angular/core';
import { CustomTranslateService } from 'src/app/shared/services/custom-translate.service';

@Pipe({
  name: 'translateDynamicLanguageTable',
  pure: false,
})
export class TranslateDynamicLanguageTablePipe implements PipeTransform {
  constructor(private translateService: CustomTranslateService) {}

  transform(value: any): any {
    return this.translateService.getMultilingualFieldValueWithEnglishDefaultTable(value);
  }
}